
import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { GraduationCap } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

interface CPDSummary {
  totalHours: number;
  yearHours: number;
}

export const CPDSummary = () => {
  const [summary, setSummary] = useState<CPDSummary>({ totalHours: 0, yearHours: 0 });

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const currentYear = new Date().getFullYear();
        const startOfYear = `${currentYear}-01-01`;
        
        // Fetch all CPD records
        const { data: records, error } = await supabase
          .from('cpd_records')
          .select('hours, date');

        if (error) throw error;

        const totalHours = records?.reduce((sum, record) => sum + record.hours, 0) || 0;
        const yearHours = records?.reduce((sum, record) => {
          if (new Date(record.date).getFullYear() === currentYear) {
            return sum + record.hours;
          }
          return sum;
        }, 0) || 0;

        setSummary({ totalHours, yearHours });
      } catch (error) {
        console.error('Error fetching CPD summary:', error);
      }
    };

    fetchSummary();
  }, []);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">CPD Hours</CardTitle>
        <GraduationCap className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="space-y-1.5">
          <div>
            <p className="text-2xl font-bold">{summary.totalHours.toFixed(1)}</p>
            <p className="text-xs text-muted-foreground">Total CPD Hours</p>
          </div>
          <div>
            <p className="text-xl font-semibold">{summary.yearHours.toFixed(1)}</p>
            <p className="text-xs text-muted-foreground">Hours this year</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
